import * as _ from "lodash-es";
import React, { Component } from "react";
import IGetOrdersDetailReportDTO from "../../../../models/DTO/IGetOrdersDetailReportDTO";
import IOnGetOrdersDetailReportDTO from "../../../../models/DTO/IOnGetOrdersDetailReportDTO";
import IAddress from "../../../../models/IAddress";
import IOrder from "../../../../models/IOrder";
import IShipment_Group from "../../../../models/IShipment_Group";
import IShipment_Groups_Orders_Map from "../../../../models/IShipment_Groups_Orders_Map";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import IVendorModel from "../../../../models/IVendorModel";
import OrderStatesEnum from "../../../../models/OrderStatesEnum";
import ReportTypeEnum from "../../../../models/ReportTypeEnum";
import ReportPeriodType from "../../../../models/ReportPeriodTypeEnum";
import UserService from "../../../../services/UserService";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OrdersDetailReportOrderRow from "./OrdersDetailReportOrderRow/OrdersDetailReportOrderRow";
import IProcessed_Report from "../../../../models/IProcessed_Report";

type Props = {
    supplierModel: ISupplierModel;
    vendorModel: IVendorModel;
    userModel: IUserUI;
    processedReport: IProcessed_Report;
};

type State = {
    orders: IOrder[];
    shipment_groups_orders_map: IShipment_Groups_Orders_Map[];
    shipment_groups: IShipment_Group[];
    startDate: string;
    endDate: string;
};

class OrdersDetailReport extends Component<Props, State> {
    readonly state: State = {
        orders: [],
        shipment_groups: [],
        shipment_groups_orders_map: [],
        startDate: "",
        endDate: "",
    };

    componentDidMount(): void {
        const data = this.props.processedReport.report_data as IOnGetOrdersDetailReportDTO;

        this.setState({
            orders: data.orders,
            shipment_groups: data.shipmentGroups,
            shipment_groups_orders_map: data.shipmentGroupOrdersMap,
            startDate: data.periodStart,
            endDate: data.periodEnd,
        });
    }

    componentWillUnmount(): void {}

    onGetOrdersDetailReport = (data: IOnGetOrdersDetailReportDTO) => {};

    processDate = (dateStr: string) => {
        if (!dateStr.length) {
            return null;
        }

        return UserService.parseDate(dateStr);
    };

    getOrderState = (order: IOrder) => {
        const state = order.order_state_id;

        switch (state) {
            case OrderStatesEnum.CONFIRMED:
                return "Confirmed";
        }

        return _.startCase((order?.Order_State?.name || "").toLowerCase());
    };

    exportCsv = () => {
        const rows = [
            [
                "Order #",
                "Status",
                "Order Created At",
                "Order Submitted At",
                "User Name",
                "User Email",
                "Customer Name",
                "Ship To Address",
                "Line #",
                "SKU",
                "Item Description",
                "Item Category",
                "Order Qty.",
            ],
        ];

        for (const order of this.state.orders) {
            for (const order_item of order.Order_Items) {
                const shipTo = order.Ship_To || order?.Vendor?.Ship_To || ({} as IAddress);
                const row = [
                    `${order.name}`,
                    `${this.getOrderState(order)}`,
                    `${this.processDate(order.created_at)}`,
                    `${this.processDate(order?.submit_date || "") || ""}`,
                    `${order?.User?.name}`,
                    `${order?.User?.email}`,
                    `${order?.Vendor?.name}`,
                    `${shipTo.address_line_one} ${shipTo.address_line_two || ""} ${shipTo.address_line_three || ""}\t${shipTo.city} ${
                        shipTo.state
                    } ${shipTo.postal_code}\t${shipTo.country}`,
                    `${order_item.item_no}`,
                    `${order_item?.Catalog_Item?.sku}`,
                    `${order_item?.Catalog_Item?.description || ""}`,
                    `${order_item?.Catalog_Item?.Category?.name || ""}`,
                    `${order_item.qty}`,
                ];

                console.log("row", row);

                rows.push(row);
            }
        }

        const csvContent = rows.map((e) => e.join(",")).join("\n");

        const blob = new Blob([csvContent], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        const fileName = `Order Detail Report - ${this.processDate(this.state.startDate)} - ${this.processDate(this.state.endDate)}.csv`;

        link.download = fileName;
        link.click();
    };

    render() {
        return (
            <div className="OrdersDetailReport">
                <div className={"mb-3"}>
                    <OwTitle title={"orders_detail_report"} />
                </div>
                <div className={"mb-5"}>
                    <b>
                        <OwLabel className={"me-2"} title={"report_period"} />
                    </b>
                    <span>
                        {this.processDate(this.state.startDate)} - {this.processDate(this.state.endDate)}
                    </span>
                    <div className={"d-print-none mt-2"}>
                        <OwLabel
                            leftIconClass={"fad fa-cloud-download"}
                            className={"pointer"}
                            title={"export_csv"}
                            fn={this.exportCsv}
                            noBottomMargin={true}
                        />
                    </div>
                </div>
                {this.state.orders.map((order) => {
                    return (
                        <OrdersDetailReportOrderRow
                            key={order.guid}
                            order={order}
                            supplierModel={this.props.supplierModel}
                            userModel={this.props.userModel}
                        />
                    );
                })}
            </div>
        );
    }
}

export default OrdersDetailReport;
